import React from "react";
import { withNamespaces } from "react-i18next";

import { AuthContextValue } from "../../../context/AuthContext";
import useFetch from "../../../hooks/UseFetch";
import WhiteButton from "../../form_components/Buttons/WhiteButton/WhiteButton";
import { Link } from "react-router-dom";
import ErrorComponent from "../../ErrorComponent/ErrorComponent";
import Loading from "../../Loading/Loading";

function CompanyApplications({t}) {
  const { token } = AuthContextValue();

  const {
    error: companiesApplyingError,
    loading: companiesApplyingLoading,
    data: companiesApplying,
  } = useFetch(
    `${
      process.env.REACT_APP_GET_COMPANIES_APPLYING_URL
    }?page=${1}&pageSize=${5}`,
    token
  );

  return (
    <div className="card-container">
      <div className="card-top">
        <div className="card-title">
          <i className="fa-solid fa-calendar-check"></i>
          <h5>{t("companies_applying_title")}</h5>
        </div>
        <div className="card-buttons">
          <Link to={"/companies-applying"}>
            <WhiteButton
              icon={<i className="fa-solid fa-info"></i>}
              tooltip={t("button_edit_detail")}
            />
          </Link>
        </div>
      </div>
      <div className="card-main">
        <ul>
          {companiesApplyingError ? (
            <ErrorComponent error={companiesApplyingError} />
          ) : companiesApplyingLoading ? (
            <Loading />
          ) : companiesApplying !== null && companiesApplying.length > 0 ? (
            companiesApplying.map((company) => {
              return (
                <li key={company.invitedId}>
                  <p>{company.invitedCompanyName}</p>
                </li>
              );
            })
          ) : (
            <p className="table-null-text">{t("message_no_application_company")}</p>
          )}
        </ul>
      </div>
    </div>
  );
}

export default withNamespaces()(CompanyApplications);
